<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-store">
      Brands
      <template v-slot:buttons>
        <v-btn :to="{name: 'admin.brand.create'}"
               color="primary">
          New Brand
        </v-btn>
      </template>
    </page-title>

    <p>
      Brands are useful for reporting and finding content. Create a brand and associate it with presentations and email templates. Then, we can build reports for you in Metabase using these relationships.
    </p>

    <v-card>
      <brands-table :brands="brands"
                    :loading="busy"
                    @updated="fetchData">
      </brands-table>
    </v-card>
  </v-container>
</template>
<script>
import BrandsTable from './components/BrandsTable';
import {mapGetters} from 'vuex';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, BrandsTable},
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    ...mapGetters('content', [
      'brands',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      this.$store.dispatch('content/fetchBrands')
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
